import { createContext } from 'react';

const ProductImpressionsContext = createContext({
	productImpressionsReporter: null,
	productImpressionsReporterGA4: null
});

export default ProductImpressionsContext;
